var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "div",
          {
            staticStyle: {
              height: "140px",
              "justify-content": "space-between",
              display: "flex"
            },
            on: { click: _vm.triggerUpload }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "text-align": "center",
                  border: "1px solid #BDC3C7"
                }
              },
              [
                _c("p", { staticStyle: { "font-size": "24px" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.DragUploadTheFileIdentified"))
                  )
                ]),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.SupportUploadFormat")) +
                      "pdf/xls/xlsx/doc/docx/jpg/gif/png/tif/rtf"
                  )
                ])
              ]
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("intelligent-booking-table", {
              attrs: {
                "row-data": _vm.rowData,
                "tab-type": "tabPending",
                "config-module": "310201"
              },
              on: {
                showDetails: function(e) {
                  return this$1.$emit("showDetails", e)
                },
                refresh: _vm.fetchData
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "intelligent-tab-pending",
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.queryPageHandler
              }
            })
          ],
          1
        ),
        _c("drop-uploader", {
          ref: "dropUploader",
          attrs: {
            action: _vm.URL.AIdiscern.importAndAnalyseFile,
            "upload-params": {
              source: _vm.source,
              iChannel: "0",
              pageSource: "intelligentBook",
              officeId: _vm.$store.getters.currentOfficeId
            },
            accept: [
              "pdf",
              "xls",
              "xlsx",
              "doc",
              "docx",
              "jpg",
              "gif",
              "png",
              "tif",
              "msword",
              "ms-excel",
              "jpeg",
              "rtf"
            ],
            "file-format": _vm.fileFormat,
            "open-drag": _vm.openDrag
          },
          on: { "upload-end": _vm.uploadEnd }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }